<template>
<main class="row onboarding-wrapper">
    <div class="col-md-12 ob-rightcol" v-if="!loading">
        <template v-if="currentStep == 1">
            <div class="primary-heading" >
                Thanks, <span class="text-capitalize">{{agent.name.firstName}}!</span>  Now let’s double-check the deets you’d like to have show up in your marketing materials.
            </div>
            <div class="secondary-heading">
                If it looks good then click “Next”. If not, edit as you desire and then proceed!
            </div>
            <div class="state-agent w800 mt-4" >
                <div class="row row-reverse">
                    <div class="col-md-6">
                        <div class="sa-frm-row mb-1">
                            <div class="sa-form-control" >
                                <input
                                type="text"
                                class="sa-control"
                                v-model="agent.name.firstName"
                                placeholder="First Name"
                                @keyup="errorText = ''"
                                >
                            </div>
                            <div v-if="errorText == 'nameRequired'" class="sa-label error-text" style="text-align:left;">Please fill at least 1 of these fields.</div>
                        </div>
                        <div class="sa-frm-row mb-1 mt-1">
                            <div class="sa-form-control" >
                                <input
                                type="text"
                                class="sa-control"
                                v-model="agent.name.lastName"
                                placeholder="Last Name"
                                @keyup="errorText = ''"
                                >
                            </div>
                            <div v-if="errorText == 'nameRequired'" class="sa-label error-text" style="text-align:left;">Please fill at least 1 of these fields.</div>
                        </div>
                        <div class="sa-frm-row mb-1 mt-1">
                            <div class="sa-form-control" >
                                <input
                                type="text"
                                class="sa-control"
                                v-model="brokerage.title"
                                placeholder="email"
                                :disabled="true"
                                @keyup="errorText = ''"
                                style="text-transform: capitalize;"
                                >
                            </div>
                        </div>
                        <div class="sa-frm-row mb-1 mt-1">
                            <div class="sa-form-control">
                                <input
                                type="text"
                                class="sa-control"
                                v-model="agentPhone"
                                placeholder="Phone"
                                @keyup="errorText = ''"
                                v-mask="'(###) ###-####'"
                                >
                            </div>
                            <div v-if="errorText == 'wrongPhone'" class="sa-label error-text" style="text-align:left;">Phone number is not correct.</div>
                        </div>
                        <div class="sa-frm-row mb-1 mt-1">
                            <div class="sa-form-control">
                                <input
                                type="text"
                                class="sa-control"
                                v-model="agentEmail"
                                placeholder="email"
                                :disabled="true"
                                @keyup="errorText = ''"
                                >
                            </div>
                            <div v-if="errorText == 'wrongEmail'" class="sa-label error-text" style="text-align:left;">Please provide a proper email</div>
                        </div>
                        <div class="sa-frm-row mb-1 mt-1">
                            <div class="sa-form-control">
                                <input
                                type="text"
                                class="sa-control"
                                v-model="agent.additionalDetails.website"
                                placeholder="Website"
                                @keyup="errorText = ''"
                                @blur="formatLink()"
                                >
                            </div>
                            <div v-if="errorText == 'wrongWebLink'" class="sa-label error-text" style="text-align:left;">Please provide a proper web link</div>
                        </div>


                        <div class="ob-btn-wrapper mt-2" style="float:left;text-align:center;">
                            <button class="ob-button" style = "alignItems:center" @click ="saveDataToWorbix(2)">Next</button>
                        </div>
                        <div class="step-wrapper">
                            <span class="stepCount" >{{currentStep}} of 4</span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="left-img-wrap">
                            <img src="@/assets/images/newui/proile_placeholder_4x.png" alt="">
                        </div>
                    </div>
                </div>

            </div>
        </template>
        <template v-if="currentStep == 2">
            <div class="primary-heading" >
                I see you’re at <span style="text-transform:capitalize;">{{brokerage.title}}!</span>
            </div>
            <div class="secondary-heading">
                Is this the office address you want on your materials?
            </div>
            <div class="state-agent  mt-4" style="max-width: 400px;">
                <div class="sa-frm-row mb-1">
                    <div class="sa-form-control" >
                        <input
                        type="text"
                        class="sa-control"
                        v-model="agentAddress.line1"
                        placeholder="Address line 1"
                        @keyup="errorText = ''"
                        >
                    </div>
                    <div v-if="errorText == 'addressMissing' && !agentAddress.line1" class="sa-label error-text" style="text-align:left;">This field is mandatory.</div>
                </div>
                <div class="sa-frm-row mb-1 mt-1">
                    <div class="sa-form-control" >
                        <input
                        type="text"
                        class="sa-control"
                        v-model="agentAddress.city"
                        placeholder="City"
                        @keyup="errorText = ''"
                        >
                    </div>
                    <div v-if="errorText == 'addressMissing' && !agentAddress.city" class="sa-label error-text" style="text-align:left;">This field is mandatory.</div>
                </div>
                <div class="sa-frm-row mb-1 mt-1">
                    <div class="sa-form-control" >
                        <input
                        type="text"
                        class="sa-control"
                        v-model="agentAddress.state"
                        placeholder="State"
                        @keyup="errorText = ''"
                        >
                    </div>
                    <div v-if="errorText == 'addressMissing' && !agentAddress.state" class="sa-label error-text" style="text-align:left;">This field is mandatory.</div>

                </div>
                <div class="sa-frm-row mb-1 mt-1">
                    <div class="sa-form-control" >
                        <input
                        type="text"
                        class="sa-control"
                        v-model="agentAddress.zipCode"
                        placeholder="Zipcode"
                        @keyup="errorText = ''"
                        >
                    </div>
                    <div v-if="errorText == 'addressMissing' && !agentAddress.zipCode" class="sa-label error-text" style="text-align:left;">This field is mandatory.</div>
                </div>
                <div class="ob-btn-wrapper mt-2" style="float:left;text-align:center;">
                    <button class="ob-button" style = "alignItems:center" @click = "saveDataToWorbix(3)">Next</button>
                </div>
                <div class="step-wrapper">
                    <span class="navigation-btn" @click="currentStep = 1">Previous</span>
                    <span class="stepCount" >{{currentStep}} of 4</span>
                </div>
            </div>
        </template>
        <template v-if="currentStep == 3">
            <div class="primary-heading" >
                Now, let’s dig up that fave photo of yours.
            </div>
            <div class="secondary-heading w600 mt-2">
                Upload a high resolution photo you’d like in your marketing.
            </div>
            <div class="secondary-heading w600 mt-3" style="font-style: italic;">
                Note: High resolution images are usually a few MBs in size.
            </div>
            <div class="state-agent mt-4" >
                <div class="row row-reverse">
                    <div class="col-md-12 agent-photo-wrpper">
                            <div class="sa-frm-row col-sm-12 pl-0 pr-0">
                                <div class="agent-photo" title="Click here to update photo." style="border-radius: 0;">
            							<input
            								ref = "file-input"
            								style = "display:none"
            								class="choose"
            								type="file"
            								placeholder="Import Product From csv"
            								multiple="false"
            								accept=".image/*,.jpeg,.jpg,.png"
            								@change.stop="uploadImage"
            							>
                                    <img  alt="" :src="getSelectedImg()" @click.stop = "openUploader" ref = "profile-image" id='profile-img'/>
                                </div>
                            </div>
                            <div class="edit-photo" @click="openUploader" v-if="profileImagePresent">Change Picture</div>
                            <div class="edit-photo" @click="openUploader" v-else>Upload Picture</div>
                    </div>
                </div>
                <div class="sa-frm-row mb-1">
                    <div v-if="errorText == 'imageRequired'" class="sa-label error-text" style="text-align:left;">Please select an image or skip this step.</div>
                </div>
                <div class="ob-btn-wrapper" v-if="newImageUploaded">
                    <button class="ob-button" style = "alignItems:center" @click = "saveDataToWorbix(4)">Save and Next</button>
                </div>
                <div class="step-wrapper">
                    <span class="navigation-btn" @click="currentStep = 2;errorText='';newImageUploaded = false;">Previous</span>
                    <span class="navigation-btn ml-4" @click="skipFromImageUpload">Skip This Step</span>
                    <span class="stepCount" >{{currentStep}} of 4</span>
                </div>
            </div>
        </template>

        <template v-if="currentStep == 4">
            <div class="primary-heading" >
                Add a payment method to complete your profile.
            </div>
            <div class="secondary-heading">
                Adding a credit card will expedite the checkout process. Or skip this step and we will prompt you when needed.
            </div>
            <div class="state-agent  mt-4" >
    			<AddCard ref="addcardForm" />
                <div class="ob-btn-wrapper mt-5" style="float:left;text-align:center;">
        			<button
        				class="ob-button"
        				style="alignItems:center"
        				@click="submitPaymentForm()"
        			>Save and Continue</button>
        		</div>
        		<div class="step-wrapper">
        			<span class="navigation-btn" @click="currentStep = 3">Previous</span>
        			<span class="navigation-btn ml-4" @click="skipToSummary">Skip This Step</span>
        			<span class="stepCount" >4 of 4</span>
        		</div>
            </div>
        </template>
    </div>
    <Confirmation  v-if="showPopup" @closePopup="closePopup" @goForward="goForward"></Confirmation>
    <div class="loader-spinner"  v-if="loading"></div>
    <div id="panelBackdrop" v-if="showPopup"></div>

</main>
</template>

<script>
// @ is an alias to /src
import AgentLogo from '@/components/agent-logo.vue'
import FooterLeft from '@/components/footer-left.vue'
import Confirmation from '@/components/Confirmation.vue'
import AddCard from '../views/AddCard.vue'
import {appEnv, demoNRDS, demoPersonId, worbixServerUrl} from '@/properties'
export default {
    name: 'ProfileSetup',
    components: {
        AgentLogo,
        FooterLeft,
        AddCard,
        Confirmation
    },
	data(){
		return{
			selectedImg:"",
			profileImage:"",
            newImageUploaded:false,
			selectedImgObj : null,
            loading:false,
            showPopup:false,
            appEnv:'dev',
            errorText:'',
            currentStep:1,
            agentPhone:'',
            dummyAddress:{
                addressType: "WORK",
                city: null,
                line1: null,
                state: null,
                type: "com.worbix.model.BasicProfile.Address",
                valueClass: "com.worbix.model.BasicProfile$Address",
                zipCode: null,
            }
		}
	},
    mounted() {
        this.appEnv = appEnv;
        // console.log('appEnv', this.appEnv);
        this.personId = this.$route.params.personId
        this.personId = (this.personId == demoNRDS) ? demoPersonId : this.personId;
        this.getBasicProfile();
    },
	computed:{
		agent(){
			return this.$store.state.basicProfile
		},
		brokerage(){
			return this.$store.state.brokerage
		},
        agentEmail:{
            set(val){
                this.agent.emails[0].email = val;
            },
            get(){
                let email = null;
                if (this.agent && this.agent.emails && this.agent.emails.length) {
                    email = this.agent.emails[0].email;
                }
                return email;
            }
        },
        agentPhone2:{
            set(val){
                let workPhone = this.agent.phoneDetails.filter((item)=>{
                    return item.type == 'MOBILE';
                });
                if (workPhone.length) {
                    workPhone[0].numberString = val;
                }
                // console.log({workPhone});
            },
            get(){
                let workPhone = '';
                if (this.agent && this.agent.phoneDetails && this.agent.phoneDetails.length) {
                    workPhone = this.agent.phoneDetails.filter((item)=>{
                        return item.type == 'MOBILE';
                    });
                    workPhone = (workPhone.length && workPhone[0].numberString) ? workPhone[0].numberString : ''
                }
                console.log({workPhone});
                return workPhone;
            }
        },
        agentAddress:{
            set(val){
                let workaddres = this.agent.addresses.filter((item)=>{
                    return item.addressType == 'WORK';
                });
                workaddres = workaddres.length ? workaddres[0] : this.dummyAddress
                workaddres = val;
            },
            get(){
                let workaddres = null;
                if (this.agent && this.agent.addresses && this.agent.addresses.length) {
                    workaddres = this.agent.addresses.filter((item)=>{
                        return item.addressType == 'WORK';
                    });
                    workaddres = workaddres.length ? workaddres[0] : this.dummyAddress
                }
                workaddres = {...this.dummyAddress, ...workaddres};
                return workaddres;
            }
        }
	},
	methods:{
		getSelectedImg(){
            let img = ``;
            var element = document.getElementById("profile-img");
            if(this.selectedImg){
                img = this.selectedImg;
            }
            else{
                img = require("@/assets/images/newui/dp_placeholder.png")
            }
            return img
		},
		uploadImage(evt){
			let file = evt.target.file || evt.target.files[0]
            if (file && file.type.indexOf('image/') == -1) {
                alert('Please select an image file');
                return;
            }
            this.errorText = '';
			let fileReader = new FileReader();
			fileReader.readAsDataURL(file);
            this.loading = true;
			fileReader.onload = e =>{
				this.selectedImg = e.target.result;
                this.$store.dispatch('uploadProfileImage', {
                        'file':this.selectedImg,
                        'name':this.agent.UID,
                        'resourceId':this.personId
                }).then((imgData)=> {
                    this.newImageUploaded = true;
                    this.loading = false;
                    this.selectedImgObj = imgData.path;
                })
			};
		},
		openUploader(){
			this.$refs["file-input"].click();
		},
        fetchInvitation(){
            let payload = {
                code : this.code,
            }
            this.loading = true;
            this.$store.dispatch("fetchInvitation", payload).then((res) => {
                this.loading = false;
                this.invitationObj = res;
            })
        },
        getBasicProfile(){
            let vm  = this;
            let payload = {
                personId : this.personId,
            }
            this.loading = true;
            this.$store.dispatch("getBasicProfile", payload).then((res) => {
                if (this.agent && this.agent.phoneDetails && this.agent.phoneDetails.length) {
                    let workPhone = vm.agent.phoneDetails.filter((item)=>{
                        return item.type == 'MOBILE';
                    });
                    this.agentPhone = (workPhone.length && workPhone[0].numberString) ? workPhone[0].numberString : ''
                    console.log('agentPhone', workPhone, this.agent);
                    this.formatLink();
                }
                if (res.basicProfile && res.basicProfile.profileImage) {
                    this.selectedImg = worbixServerUrl + 'a/' + res.basicProfile.profileImage;
                    this.profileImagePresent = true;
                    console.log('selectedImg', this.selectedImg);
                }
                this.loading = false;
            })

        },
        skipFromImageUpload(){
            if (this.selectedImgObj) {
                this.showPopup = true;
            }else {
                // this.currentStep = 4
                this.skipToSummary();
            }
        },
        goForward(){
            this.selectedImg = null;
            this.selectedImgObj = null;
            this.showPopup = false;
            // this.currentStep = 4;
            this.skipToSummary();
            this.newImageUploaded = false;
            this.errorText = '';
        },
        closePopup(){
            this.showPopup = false;
        },
        validateEmail(email){
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validateLink(link){
            link = link.toLowerCase();
            const re = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
            return re.test(link);
        },
        validatePhone(phone){
            phone = phone;
            const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
            return re.test(phone);
        },
        formatLink(){
            let link = this.agent.additionalDetails.website;
            if (link && !link.match(/^[a-zA-Z]+:\/\//))
                {
                    link = 'http://' + link;
                }
                this.agent.additionalDetails.website = link;
        },
        submitPaymentForm(){
            this.$refs['addcardForm'].submitForm();
        },
        skipToSummary(){
            this.$router.push({
                path:'/summary'
            })
        },
		saveDataToWorbix(nextStep){
			let vm = this;
			let payload = {}
            if (!this.agent.name.lastName && !this.agent.name.firstName) {
                this.errorText = 'nameRequired'
                return false;
            }
            if (!this.validateEmail(this.agentEmail)) {
                this.errorText = 'wrongEmail'
                return false;
            }
            if (!this.validatePhone(this.agentPhone)) {
                this.errorText = 'wrongPhone'
                return false;
            }else {
                let workPhone = this.agent.phoneDetails.filter((item)=>{
                    return item.type == 'MOBILE';
                });
                if (workPhone.length) {
                    workPhone[0].numberString = this.agentPhone;
                }
            }
            if (this.agent.additionalDetails.website && !this.validateLink(this.agent.additionalDetails.website)) {
                this.errorText = 'wrongWebLink'
                return false;
            }
            if(!this.selectedImgObj && nextStep == 4){
                this.errorText = 'imageRequired'
                return false;
            }
            if (nextStep == 3) {
                Object.keys(this.agentAddress).every((item, i) => {
                    if (!this.agentAddress[item]) {
                        this.errorText = 'addressMissing';
                        return false;
                    }else {
                        return true;
                    }
                });
                if (this.errorText) {
                    return false;
                }

                let workIndex = this.agent.addresses.findIndex((item)=>{
                    return item.addressType == 'WORK';
                })
                this.agent.addresses[workIndex] = {...this.agent.addresses[workIndex], ...this.agentAddress};
            }
            this.loading = true;
            payload['basicProfile'] = {...this.agent};
            payload.personId = parseInt(this.personId);
            payload.createSenderProfile = false;
            if(this.selectedImgObj){
                payload['basicProfile'].profileImage = this.selectedImgObj;
            }

            this.$store.dispatch("updateProfile", payload).then((res) => {
                this.loading = false;
                this.newImageUploaded = false;
                if (nextStep == 4) {
                    this.skipToSummary();
                }else {
                    this.currentStep = nextStep;
                }
            })
		}
	}
}
</script>

<style lang="scss">
 .img-style{
	 height: 102px;
    width: 102px;
 }
 #profile-img{
     max-width: 100%;
     max-height: 100%;
 }
 .error-text{
     color: #ff0000;
     float: left;
     font-size: 25px;
 }
 .section-wrapper{
     padding: 20px;
     padding-right: 5px;
     float: left;
     width: 100%;
     border: 1px solid #eee;

 }
 .left-img-wrap img{
     max-width: 100%;
    max-height: 300px;
 }
 .agent-photo-wrpper{
     &:hover{
        .edit-photo{
            display:flex;
        }
     }
 }
 .edit-photo{
     position: absolute;
     top: 36%;
     background: #b5e6f6;
     height: 20px;
     width: 152px;
     font-size: 10px;
     opacity: 0.7;
     left: calc((100% - 152px)/2);
     align-items: center;
     justify-content: center;
     cursor: pointer;
     display: none;
 }
</style>
